{
  "name": "angular-template-2025-07",
  "version": "1.0.21",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "eslint .",
    "lint:fix": "eslint . --fix",
    "format": "prettier . --write",
    "format:check": "prettier . --check",
    "generate:feature": "node ./tools/generators/generate-feature.mjs",
    "generate:component": "node ./tools/generators/generate-component.mjs",
    "prepare": "husky"
  },
  "private": true,
  "dependencies": {
    "@angular/common": "^20.3.17",
    "@angular/compiler": "^20.3.17",
    "@angular/core": "^20.3.17",
    "@angular/forms": "^20.3.17",
    "@angular/platform-browser": "^20.3.17",
    "@angular/router": "^20.3.17",
    "@angular/service-worker": "20.3.17",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^20.3.19",
    "@angular/cli": "^20.3.19",
    "@angular/compiler-cli": "^20.3.17",
    "@eslint/js": "^9.22.0",
    "@types/jasmine": "~5.1.15",
    "eslint": "^9.22.0",
    "eslint-config-prettier": "^10.1.1",
    "husky": "^9.1.7",
    "jasmine-core": "~5.7.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "prettier": "^3.5.3",
    "typescript": "~5.8.2",
    "typescript-eslint": "^8.26.1"
  }
}
